import React from 'react';
import { ScrollParallax } from "react-just-parallax";
import { Link } from 'react-router-dom';
import DefaultButton from './DefaultButton';
import oroPuroMani from "../assets/lingotti/0060 - Still life Care is gold-Modifica.webp";

function MinimalSection({ 
    orientation, 
    background, 
    title, 
    description, 
    href, 
    imageUrl, 
    titleClass, 
    descriptionClass, 
    darkButton, 
    strength, 
    lerp, 
    imgOpacity, 
    firstButtonText, 
    buttonClass1, 
    buttonClass2, 
    secondButton, 
    secondButtonText, 
    href2, 
    ariaLabelledbyFirst, 
    ariaLabelledbySecond, 
    idFirstButton, 
    idSecondButton,
    headingIdFirst,
}) {

    const createMarkup = (htmlContent) => {
        return { __html: htmlContent };
    };

    return (
        <>
            {orientation === 'left' ? (
                <>
                    <section>
                        <div className='mx-auto'>
                            <div className='h-lvh mini-screen:h-[600px] flex justify-center items-center'>
                                <div className={`${imgOpacity} h-lvh hidden sm:block sm:w-1/4 z-0`}>
                                    <ScrollParallax lerpEase={lerp} zIndex='0' enableOnTouchDevice={false} strength={strength}>
                                        <img src={imageUrl} alt={title} className='w-full h-full object-cover' />
                                    </ScrollParallax>
                                </div>
                                <div className={`h-lvh w-full sm:w-3/4 ${background} flex justify-center items-center p-4 z-20`}>
                                    <div className='flex flex-col justify-center items-start text-left w-full sm:max-w-md lg:max-w-lg xl:max-w-xl mx-auto'>
                                        <div className={`md:text-5xl font-semibold mb-5 ${titleClass} text-balance`} data-aos="fade-up" data-aos-duration="900">
                                            <h2 id={headingIdFirst}>
                                                {title}
                                            </h2>
                                        </div>
                                        <div data-aos="fade-zoom-in" data-aos-duration="1000" 
                                        className={` text-lg mb-5 ${descriptionClass} mini-screen:text-base text-balance`}>{description}</div>

                                        <div className='flex flex-col justify-center items-start text-left w-full sm:max-w-md lg:max-w-lg xl:max-w-xl mx-auto'>
                                            <DefaultButton 
                                                id={idFirstButton} 
                                                text={firstButtonText || 'Scopri di più'} 
                                                link={href}
                                                dark={darkButton} 
                                                buttonClass={buttonClass1} 
                                                ariaLabelledby={ariaLabelledbyFirst} />

                                            {secondButton && 
                                                <DefaultButton 
                                                    id={idSecondButton} 
                                                    text={secondButtonText || 'Scopri di più'} 
                                                    link={href2} 
                                                    dark={darkButton} 
                                                    buttonClass={buttonClass2} 
                                                    ariaLabelledby={ariaLabelledbySecond} 
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <>
                    <section>
                        <div className='mx-auto'>
                            <div className={`h-lvh mini-screen:h-[750px] flex justify-center items-center`}>
                                <div className={`h-screen mini-screen:h-full w-full sm:w-3/4 ${background} 
                                flex justify-center items-center p-4 z-20`}>
                                    <div className='text-left w-full sm:max-w-md lg:max-w-lg xl:max-w-xl mx-auto'>
                                        <div className={`md:text-5xl font-semibold mb-5 ${titleClass} text-balance`} data-aos="fade-up" data-aos-duration="900">
                                            <h2 id={headingIdFirst}>
                                                {title}
                                            </h2>
                                        </div>
                                        <div data-aos="fade-zoom-in" data-aos-duration="1000" 
                                        className={` text-lg mb-5 ${descriptionClass} mini-screen:text-base text-balance`} >{description}</div>
                                        <div className='flex flex-col justify-center items-start text-left w-full sm:max-w-md lg:max-w-lg xl:max-w-xl mx-auto'>
                                            <DefaultButton 
                                            id={idFirstButton} 
                                            text={firstButtonText || 'Scopri di più'} 
                                            link={href} dark={darkButton} 
                                            buttonClass={buttonClass1} 
                                            ariaLabelledby={ariaLabelledbyFirst} />
                                            
                                            {secondButton && 
                                                <DefaultButton 
                                                id={idSecondButton} 
                                                text={secondButtonText || 'Scopri di più'} 
                                                link={href2} dark={darkButton} 
                                                buttonClass={buttonClass2} 
                                                ariaLabelledby={ariaLabelledbySecond} />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={`${imgOpacity} h-lvh hidden sm:block sm:w-1/4 z-0`}>
                                    <ScrollParallax lerpEase={lerp} zIndex='0' enableOnTouchDevice={false} strength={strength}>
                                        <img src={imageUrl} alt={title} className='w-full h-full object-cover' />
                                    </ScrollParallax>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </>
    );
}

export default MinimalSection;


